
import React from 'react';
import { BRAND_WORDMARK } from '@financialharmony/ui/brand';

interface HarmonyLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const HarmonyLogo: React.FC<HarmonyLogoProps> = ({ 
  className = "", 
  size = 'md', 
  showText = true 
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  const circleSizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-6 w-6'
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Harmony Logo - Black square with white circle */}
      <div className={`${sizeClasses[size]} bg-black rounded-md flex items-center justify-center`}>
        <div className={`${circleSizeClasses[size]} bg-white rounded-full`}></div>
      </div>
      {showText && (
        <span className={`font-semibold text-black ${textSizeClasses[size]}`}>
          {BRAND_WORDMARK}
        </span>
      )}
    </div>
  );
};

export default HarmonyLogo;
